export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const AJAX_CALL_ERROR = "AJAX_CALL_ERROR";
export const APPLICATION_ERROR = "APPLICATION_ERROR";
export const INIT_SESSION = "INIT_SESSION";

export const USER_AUTHENTICATE = "USER_AUTHENTICATE";
export const USER_AUTHENTICATE_SUCCESS = "USER_AUTHENTICATE_SUCCESS";
export const USER_AUTHENTICATE_FAILURE = "USER_AUTHENTICATE_FAILURE";
export const USER_AUTHENTICATE_REFRESH = "USER_AUTHENTICATE_REFRESH";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const LOGOUT_COMPLETED = "LOGOUT_COMPLETED";
export const VERIFY_LOGIN = "VERIFY_LOGIN";
export const VERIFY_LOGIN_COMPLETED = "VERIFY_LOGIN_COMPLETED";
export const REFRESH_TOKEN = "REFRESH_TOKEN";
export const REFRESH_TOKEN_FAILURE = "REFRESH_TOKEN_FAILURE";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const CHECK_IS_LOGGED_IN = "CHECK_IS_LOGGED_IN";
export const LOGIN_FORM_SUCCESS = "LOGIN_FORM_SUCCESS";
export const CLEAR_USERLOGGEDOUT_MESSAGE = "CLEAR_USERLOGGEDOUT_MESSAGE";
export const CLEAR_LOGGEDOUT_MESSAGE = "CLEAR_LOGGEDOUT_MESSAGE";
export const CLEAR_REDIRECT_URL = "CLEAR_REDIRECT_URL";
export const SET_AD_USER_DATA = "SET_AD_USER_DATA";
export const SET_AD_ID_TOKEN = "SET_AD_ID_TOKEN";
export const SET_HEALTH_SOURCE_TOKEN = "SET_HEALTH_SOURCE_TOKEN";

export const USER_TO_SWITCH = "USER_TO_SWITCH";
export const SWITCH_USER_SAGA = "SWITCH_USER_SAGA";
export const SWITCH_USER_REDUCER = "SWITCH_USER_REDUCER";
export const RESET_USER_VALUE = "RESET_USER_VALUE";

export const LOAD_DASHBOARD_START = "LOAD_DASHBOARD_START";
export const LOAD_DASHBOARD_SUCCESS = "LOAD_DASHBOARD_SUCCESS";
export const LOAD_DASHBOARD_ERROR = "LOAD_DASHBOARD_ERROR";

export const REMOVE_SLIDE = "REMOVE_SLIDE";

export const SET_SERVER_DATA = "SET_SERVER_DATA";
export const SET_HISTORY_OBJECT = "SET_HISTORY_OBJECT";

export const CHANGE_USERNAME = "CHANGE_USERNAME";
export const CHANGE_USERNAME_SUCCESS = "CHANGE_USERNAME_SUCCESS";
export const CHANGE_USERNAME_FAILURE = "CHANGE_USERNAME_FAILURE";
export const CHANGE_USERNAME_CLEAR = "CHANGE_USERNAME_CLEAR";

export const CHANGE_EMAIL_START = "CHANGE_EMAIL_START";
export const CHANGE_EMAIL_SUCCESS = "CHANGE_EMAIL_SUCCESS";
export const CHANGE_EMAIL_FAILURE = "CHANGE_EMAIL_FAILURE";
export const CHANGE_EMAIL_CLEAR_MESSAGE = "CHANGE_EMAIL_CLEAR_MESSAGE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";
export const CHANGE_PASSWORD_CLEAR = "CHANGE_PASSWORD_CLEAR";

export const FORGOT_PASSWORD_START = "FORGOT_PASSWORD_START";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_CLEAR = "FORGOT_PASSWORD_CLEAR";

export const RESET_PASSWORD_START = "RESET_PASSWORD_START";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const RESET_LOGIN_SETTINGS_DATA = "RESET_LOGIN_SETTINGS_DATA";

export const FORGOT_USERNAME_START = "FORGOT_USERNAME_START";
export const FORGOT_USERNAME_SUCCESS = "FORGOT_USERNAME_SUCCESS";
export const FORGOT_USERNAME_FAILURE = "FORGOT_USERNAME_FAILURE";
export const FORGOT_USERNAME_CLEAR = "FORGOT_USERNAME_CLEAR";

export const SET_TERMS_AND_CONDITIONS = "SET_TERMS_AND_CONDITIONS";
export const LOAD_TERMS_AND_CONDITIONS = "LOAD_TERMS_AND_CONDITIONS";
export const ACCEPT_TERMS_AND_CONDITIONS = "ACCEPT_TERMS_AND_CONDITIONS";

export const ADD_OR_UPDATE_USER_PHONE_NUMBER_START = "ADD_OR_UPDATE_USER_PHONE_NUMBER_START";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS = "ADD_OR_UPDATE_USER_PHONE_NUMBER_SUCCESS";
export const ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE = "ADD_OR_UPDATE_USER_PHONE_NUMBER_FAILURE";

export const RELOAD_KEY = "RELOAD_KEY";

export const SUBMIT_USER_FEEDBACK_FORM = "SUBMIT_USER_FEEDBACK_FORM";

export const STAY_ON_INCOMPLETE_FORM = "STAY_ON_INCOMPLETE_FORM";

export const PATIENT_DEMOGRAPHICS_START = "PATIENT_DEMOGRAPHICS_START";
export const PATIENT_DEMOGRAPHICS_SUCCESS = "PATIENT_DEMOGRAPHICS_SUCCESS";
export const PATIENT_DEMOGRAPHICS_FAILURE = "PATIENT_DEMOGRAPHICS_FAILURE";

export const GET_APP_UPDATE = "GET_APP_UPDATE";
export const HIDE_NORMAL_APP_UPDATE = "HIDE_NORMAL_APP_UPDATE";

export const GRAPHIC_BANNER_UPDATE = "GRAPHIC_BANNER_UPDATE";

export const LOAD_AAL_DATA_START = "LOAD_AAL_DATA_START";
export const LOAD_AAL_DATA_SUCCESS = "LOAD_AAL_DATA_SUCCESS";
export const LOAD_AAL_DATA_FAILURE = "LOAD_AAL_DATA_FAILURE";

export const COOKIE_BSWPROXY_START = "COOKIE_BSWPROXY_START";
export const COOKIE_BSWPROXY_SUCCESS = "COOKIE_BSWPROXY_SUCCESS";

export const UPDATE_MENU = "UPDATE_MENU";
export const HIDE_BANNER_ON_CRASH = "HIDE_BANNER_ON_CRASH";

export const UPDATE_INSURANCE_PREFERENCE = "UPDATE_INSURANCE_PREFERENCE";
export const SHOW_INSURANCE_FORM = "SHOW_INSURANCE_FORM";

export const LOAD_DASHBOARD_V2_SUCCESS = "LOAD_DASHBOARD_V2_SUCCESS";

export const SET_VIDEO_VISIT_TOASTR_MSG = "SET_VIDEO_VISIT_TOASTR_MSG";

export const START_TOKEN_EXCHANGE = "START_TOKEN_EXCHANGE";
export const END_TOKEN_EXCHANGE = "END_TOKEN_EXCHANGE";

export const POST_LOGIN_START = "POST_LOGIN_START";
export const SET_PHYND_DATA = "SET_PHYND_DATA";

export const EPIC_DEPT_LIST_GET_START = "EPIC_DEPT_LIST_GET_START";
export const EPIC_DEPT_LIST_SET_DATA = "EPIC_DEPT_LIST_SET_DATA";
export const EPIC_DEPT_LIST_GET_END = "EPIC_DEPT_LIST_GET_END";

export const EPIC_PROVIDER_APPOINTMENTS_GET_START = "EPIC_PROVIDER_APPOINTMENTS_GET_START";
export const EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE = "EPIC_PROVIDER_APPOINTMENTS_GET_FAILURE";
export const EPIC_PROVIDER_APPOINTMENTS_SET_DATA = "EPIC_PROVIDER_APPOINTMENTS_SET_DATA";
export const EPIC_PROVIDER_APPOINTMENTS_GET_END = "EPIC_PROVIDER_APPOINTMENTS_GET_END";
export const SAME_DAY_CARE_APPOINTMENTS_GET_START = "SAME_DAY_CARE_APPOINTMENTS_GET_START";
export const SAME_DAY_CARE_APPOINTMENTS_GET_FAILURE = "SAME_DAY_CARE_APPOINTMENTS_GET_FAILURE";
export const SAME_DAY_CARE_APPOINTMENTS_SET_DATA = "SAME_DAY_CARE_APPOINTMENTS_SET_DATA";
export const SAME_DAY_CARE_APPOINTMENTS_GET_END = "SAME_DAY_CARE_APPOINTMENTS_GET_END";
export const APPOINTMENTS_REFRESH_DATA = "APPOINTMENTS_REFRESH_DATA";

export const APP_START = "APP_START";

export const INSTADOC_SET_TOKEN = "INSTADOC_SET_TOKEN";
export const INSTADOC_TOKEN_GET_START = "INSTADOC_TOKEN_GET_START";
export const INSTADOC_TOKEN_GET_END = "INSTADOC_TOKEN_GET_END";
export const INSTADOC_TOKEN_REFRESH = "INSTADOC_TOKEN_REFRESH";
export const INSTADOC_SET_EMPLOYEE = "INSTADOC_SET_EMPLOYEE";
export const INSTADOC_PROVIDER_INFO_START = "INSTADOC_PROVIDER_INFO_START";
export const INSTADOC_PROVIDER_INFO_SUCCESS = "INSTADOC_PROVIDER_INFO_SUCCESS";
export const INSTADOC_PROVIDER_INFO_FAILURE = "INSTADOC_PROVIDER_INFO_FAILURE";

export const INSTADOC_PROVIDERS_START = "INSTADOC_PROVIDERS_START";
export const INSTADOC_PROVIDERS_SUCCESS = "INSTADOC_PROVIDERS_SUCCESS";
export const INSTADOC_PROVIDERS_FAILURE = "INSTADOC_PROVIDERS_FAILURE";

export const SET_PROVIDER_EPIC_IDS = "SET_PROVIDER_EPIC_IDS";

export const POSTLOGIN_PROCESS_START = "POSTLOGIN_PROCESS_START";
export const POSTLOGIN_PROCESS_END = "POSTLOGIN_PROCESS_END";

export const GET_ROOM_STATUSES_SUCCESS = "GET_ROOM_STATUSES_SUCCESS";
export const GET_ROOM_STATUSES_FAILURE = "GET_ROOM_STATUSES_FAILURE";

export const GET_PROVIDER_JWT = "GET_PROVIDER_JWT";
export const GET_PROVIDER_JWT_PENDING = "GET_PROVIDER_JWT_PENDING";
export const GET_PROVIDER_JWT_SUCCESS = "GET_PROVIDER_JWT_SUCCESS";
export const GET_PROVIDER_JWT_FAILURE = "GET_PROVIDER_JWT_FAILURE";

export const COLLAPSE_MENU = "COLLAPSE_MENU";

export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_PENDING";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_SUCCESS";
export const AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE = "AMBULATORY_VIDEO_VISIT_SURVEY_REQUEST_FAILURE";

export const IS_MOBILE_NUMBER = "IS_MOBILE_NUMBER";

export const SMS_VIDEO_VISIT_LINK = "SMS_VIDEO_VISIT_LINK";
export const SMS_VIDEO_VISIT_LINK_SUCCESS = "SMS_VIDEO_VISIT_LINK_SUCCESS";
export const SMS_VIDEO_VISIT_LINK_FAILURE = "SMS_VIDEO_VISIT_LINK_FAILURE";

export const EMAIL_VIDEO_VISIT_LINK = "EMAIL_VIDEO_VISIT_LINK";
export const EMAIL_VIDEO_VISIT_LINK_SUCCESS = "EMAIL_VIDEO_VISIT_LINK_SUCCESS";
export const EMAIL_VIDEO_VISIT_LINK_FAILURE = "EMAIL_VIDEO_VISIT_LINK_FAILURE";

export const SMS_VIDEO_VISIT_LINK_FOR_GUEST = "SMS_VIDEO_VISIT_LINK_FOR_GUEST";
export const SMS_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS = "SMS_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const SMS_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE = "SMS_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE";

export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST";
export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE = "EMAIL_VIDEO_VISIT_LINK_FOR_GUEST_FAILURE";

export const CANCEL_VIDEO_VISIT_LINK = "CANCEL_VIDEO_VISIT_LINK";
export const CANCEL_VIDEO_VISIT_LINK_SUCCESS = "CANCEL_VIDEO_VISIT_LINK_FOR_GUEST_SUCCESS";
export const CANCEL_VIDEO_VISIT_LINK__FAILURE = "CANCEL_VIDEO_VISIT_LINK_FAILURE";

export const VIDEO_VISIT_SHARE_LINK_HISTORY = "VIDEO_VISIT_SHARE_LINK_HISTORY";
export const VIDEO_VISIT_SHARE_LINK_HISTORY_SUCCESS = "VIDEO_VISIT_SHARE_LINK_HISTORY_SUCCESS";
export const VIDEO_VISIT_SHARE_LINK_HISTORY_FAILURE = "VIDEO_VISIT_SHARE_LINK_HISTORY_FAILURE";

export const SIGNALR_INIT = "SIGNALR_INIT";
export const SIGNALR_UPDATE_ROOM = "SIGNALR_UPDATE_ROOM";

export const SYNC_ROOMS = "SYNC_ROOMS";

export const EMPLOYEE_TYPES = "EMPLOYEE_TYPES";
export const ROOM_STATUSES = "ROOM_STATUSES";

export const USER_SETTINGS = "USER_SETTINGS";

export const ADAL_TOKEN_REFRESH = "ADAL_TOKEN_REFRESH";
export const GUEST_LINK_APPROVAL_STATUS = "GUEST_LINK_APPROVAL_STATUS";
export const SET_GUEST_LINK_APPROVAL_STATUS = "SET_GUEST_LINK_APPROVAL_STATUS";
export const ALLOW_GUEST = "ALLOW_GUEST";
export const DENY_GUEST = "DENY_GUEST";

export const APPOINTMENT_HISTORY = "APPOINTMENT_HISTORY";
export const APPOINTMENT_HISTORY_PENDING = "APPOINTMENT_HISTORY_PENDING";
export const APPOINTMENT_HISTORY_SUCCESS = "APPOINTMENT_HISTORY_SUCCESS";

export const CREATE_VIRTUAL_ROOM = "CREATE_VIRTUAL_ROOM";
export const CREATE_VIRTUAL_ROOM_PENDING = "CREATE_VIRTUAL_ROOM_PENDING";
export const CREATE_VIRTUAL_ROOM_SUCCESS = "CREATE_VIRTUAL_ROOM_SUCCESS";
export const CREATE_VIRTUAL_ROOM_FAILURE = "CREATE_VIRTUAL_ROOM_FAILURE";
export const SHOW_INFOFORUPDATEMOBILENO_TOOLTIP = "SHOW_INFOFORUPDATEMOBILENO_TOOLTIP";

export const SET_PARTICIPANTS = "SET_PARTICIPANTS";